"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerServices = void 0;
function registerServices(config, service) {
    if (service === void 0) { service = null; }
    var api = new ApiServiceDefault(config.api);
    var defaultService = {
        api: function () {
            return api;
        }
    };
    if (service === null) {
        return defaultService;
    }
    // Overwrite the default services
    return __assign(__assign({}, defaultService), service);
}
exports.registerServices = registerServices;
var ApiServiceDefault = /** @class */ (function () {
    function ApiServiceDefault(config) {
        this._config = config;
    }
    ApiServiceDefault.prototype.getFetchPageUrl = function () {
        return this._config.fetchPageUrl;
    };
    ApiServiceDefault.prototype.fetchPage = function (page, perPage, search, topicIds) {
        return this._config.http
            .get(this.getFetchPageUrl(), {
            params: {
                page: page,
                per_page: perPage,
                search: search,
                topic_ids: topicIds,
            }
        }).then(function (res) {
            if (!res.data) {
                throw new Error('Response data is empty.');
            }
            return res.data;
        });
    };
    return ApiServiceDefault;
}());
